import { Generator } from "@visactor/vrender-core/common/generator";

import { BaseWindowHandlerContribution, WindowHandlerContribution } from "@visactor/vrender-core";

import { TTCanvas } from "../../canvas/contributions/tt";

import { application } from "@visactor/vrender-core/application";

class MiniAppEventManager {
    constructor() {
        this.cache = {};
    }
    addEventListener(type, func) {
        type && func && (this.cache[type] = this.cache[type] || {
            listener: []
        }, this.cache[type].listener.push(func));
    }
    removeEventListener(type, func) {
        if (!type || !func) return;
        if (!this.cache[type]) return;
        const index = this.cache[type].listener.findIndex((f => f === func));
        index >= 0 && this.cache[type].listener.splice(index, 1);
    }
    cleanEvent() {
        this.cache = {};
    }
}

export class TTWindowHandlerContribution extends BaseWindowHandlerContribution {
    get container() {
        return null;
    }
    constructor(global = application.global) {
        super(), this.global = global, this.type = "tt", this.eventManager = new MiniAppEventManager;
    }
    getTitle() {
        return this.canvas.id.toString();
    }
    getWH() {
        return {
            width: this.canvas.width / (this.canvas.dpr || 1),
            height: this.canvas.height / (this.canvas.dpr || 1)
        };
    }
    getXY() {
        return {
            x: 0,
            y: 0
        };
    }
    createWindow(params) {
        params.canvas ? this.createWindowByCanvas(params) : this.createWindowByConfig(params);
    }
    createWindowByConfig(params) {
        const nativeCanvas = this.global.createCanvas({
            width: params.width,
            height: params.height
        }), options = {
            width: params.width,
            height: params.height,
            dpr: params.dpr,
            nativeCanvas: nativeCanvas,
            id: Generator.GenAutoIncrementId().toString(),
            canvasControled: !1
        };
        this.canvas = new TTCanvas(options);
    }
    createWindowByCanvas(params) {
        let canvas;
        if ("string" == typeof params.canvas) {
            if (canvas = this.global.getElementById(params.canvas), canvas || (canvas = this.global.createCanvas({
                id: params.canvas,
                width: params.width,
                height: params.height,
                dpr: params.dpr
            })), !canvas) throw new Error("canvasId 参数不正确，请确认canvas存在并插入dom");
        } else canvas = params.canvas;
        let width = params.width, height = params.height;
        if (null == width || null == height || !params.canvasControled) {
            const data = canvas.getBoundingClientRect();
            width = data.width, height = data.height;
        }
        let dpr = params.dpr;
        null == dpr && (dpr = canvas.width / width), this.canvas = new TTCanvas({
            width: width,
            height: height,
            dpr: dpr,
            nativeCanvas: canvas,
            canvasControled: params.canvasControled
        });
    }
    releaseWindow() {}
    resizeWindow(width, height) {}
    setDpr(dpr) {
        this.canvas.dpr = dpr;
    }
    getContext() {
        return this.canvas.getContext();
    }
    getNativeHandler() {
        return this.canvas;
    }
    getDpr() {
        return this.canvas.dpr;
    }
    addEventListener(type, listener) {
        this.eventManager.addEventListener(type, listener);
    }
    removeEventListener(type, listener) {
        this.eventManager.removeEventListener(type, listener);
    }
    dispatchEvent(event) {
        const {type: type} = event;
        return !!this.eventManager.cache[type] && (event.changedTouches && event.changedTouches[0] && (event.offsetX = event.changedTouches[0].x, 
        event.changedTouches[0].offsetX = event.changedTouches[0].x, event.changedTouches[0].clientX = event.changedTouches[0].x, 
        event.offsetY = event.changedTouches[0].y, event.changedTouches[0].offsetY = event.changedTouches[0].y, 
        event.changedTouches[0].clientY = event.changedTouches[0].y), event.preventDefault = () => {}, 
        event.stopPropagation = () => {}, this.eventManager.cache[type].listener && this.eventManager.cache[type].listener.forEach((f => {
            f(event);
        })), !0);
    }
    getStyle() {
        return {};
    }
    setStyle(style) {}
    getBoundingClientRect() {
        const wh = this.getWH();
        return {
            x: 0,
            y: 0,
            width: wh.width,
            height: wh.height,
            left: 0,
            top: 0,
            right: 0,
            bottom: 0
        };
    }
    clearViewBox(color) {
        const vb = this.viewBox, context = this.getContext(), dpr = this.getDpr();
        context.nativeContext.save(), context.nativeContext.setTransform(dpr, 0, 0, dpr, 0, 0), 
        context.clearRect(vb.x1, vb.y1, vb.x2 - vb.x1, vb.y2 - vb.y1), color && (context.fillStyle = color, 
        context.fillRect(vb.x1, vb.y1, vb.x2 - vb.x1, vb.y2 - vb.y1)), context.nativeContext.restore();
    }
}

TTWindowHandlerContribution.env = "tt";

export function bindTTWindowContribution(container) {
    var _a, _b;
    (null === (_a = container.isBound) || void 0 === _a ? void 0 : _a.call(container, TTWindowHandlerContribution)) || container.bind(TTWindowHandlerContribution).toSelf(), 
    (null === (_b = container.getNamed) || void 0 === _b ? void 0 : _b.call(container, WindowHandlerContribution, TTWindowHandlerContribution.env)) || container.bind(WindowHandlerContribution).toService(TTWindowHandlerContribution).whenTargetNamed(TTWindowHandlerContribution.env);
}
//# sourceMappingURL=tt-contribution.js.map
